// import contactDataTwo from '../../data/contactInfo/contactInfoTwo.json';
// import ContactInfoItem from '../../components/ContactInfo/ContactInfoItemTwo.jsx';
// import SectionTitle from '../../components/SectionTitles/SectionTitle';
import HomeDemoSection from '../../components/SectionTitles/HomeDemoSection.jsx';
// import SectionTitleTwo from '../../components/SectionTitles/SectionTitleTwo.jsx';
// import ProjectForm from '../../components/ProjectForm/ProjectForm';
import '../ContactInformation/HomeSchedules.css'


const HomeScheduleSection = () => {
    
    return (
        <div className="section section-padding contact-section overlay-two" style={{backgroundImage: `url(${process.env.PUBLIC_URL}/images/imageTrails/Home/Time2.png)`, backgroundRepeat:'no-repeat',objectFit:'cover'}} >
            <div className="container">                                                                                                                                     
                <div className="row row-cols-lg-2 row-cols-1 align-items-center">
                    <div className="col" data-aos="fade-up">
                        <div className="contact-Information mr-xl-7">
                            <HomeDemoSection 
                                classOption=""
                                
                                title="No Time Like Now To Improve The Way You Communicate"
                            />

                            {/* {contactDataTwo && contactDataTwo.map((single, key) => {
                                return(
                                    <React.Fragment key={key}>
                                        <ContactInfoItem classOption="info-light" data={single} key={key} />
                                    </React.Fragment>
                                ); 
                            })} */}
                        </div>
                    </div>
                    <div className="col mt-lg-0 mt-md-10 mt-8" data-aos="fade-up" data-aos-delay="300">
                        {/* <div className="contact-form-area">
                            <SectionTitle
                                titleOption="section-title text-center mb-7"
                                headingOption="title fz-28"
                                title="Let’s talk about your project"
                                subTitle="We have made it easy for clients to reach us
                                    and get their solutions weaved"
                            />

                            <ProjectForm />
                        </div> */}
                    </div>
                </div>
            </div>

           

        </div>
    )
}

export default HomeScheduleSection;
